import { render } from "./LandingPages.vue?vue&type=template&id=9f56dc50&ts=true"
import script from "./LandingPages.vue?vue&type=script&lang=ts"
export * from "./LandingPages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__